import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Page Not Found (404) | Dr. Arun Reddy M";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex";
    document.head.appendChild(robots);
    return () => {
      document.title = prevTitle;
      robots.remove();
    };
  }, []);

  return (
    <section className="min-h-[70vh] flex items-center bg-white" data-testid="not-found-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-24 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Error 404</p>
        <h1 className="mt-4 font-heading font-extrabold text-[#0b2c4d] tracking-tighter text-4xl sm:text-5xl lg:text-6xl">
          Page not found
        </h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed">
          The page you are looking for does not exist or may have moved. It might help to start
          from one of these:
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3 text-sm font-semibold">
          <Link to="/" data-testid="nf-home" className="text-brand underline underline-offset-4">Home</Link>
          <Link to="/slipped-disc-treatment" className="text-brand underline underline-offset-4">Slipped disc treatment</Link>
          <Link to="/endoscopic-spine-surgery" className="text-brand underline underline-offset-4">Endoscopic spine surgery</Link>
          <Link to="/blog" className="text-brand underline underline-offset-4">Blog</Link>
        </div>
        <Button
          asChild
          className="mt-10 bg-brand hover:bg-brand-hover text-white font-semibold h-12 px-7 rounded-full shadow-lg shadow-brand/25"
        >
          <Link to="/" data-testid="nf-home-btn">
            Back to homepage
            <ArrowRight className="w-4 h-4 ml-1" />
          </Link>
        </Button>
      </div>
    </section>
  );
}
